import React, { useEffect, useState } from 'react';
import {
    InputAdornment,
    FormControl,
    FilledInput,
    InputLabel
} from '@mui/material';
import { ct } from '../../../../constant-Utils';



const SearchInput = (props) => {

    const [width, setWidth] = useState("300px");

    useEffect(() => {
        if (props?.width) {
            setWidth(props.width)
        }
    }, [])
    const handleChange = (e) => {
        props.handleSearch(e)
    }

    const handleClear = () => {
        props.handleSearch("",true)
    }

    return (<FormControl
        variant="filled"
        className={"payment-input " + (props?.classes != undefined && props?.classes)}
    >
        <InputLabel htmlFor="filled-search">{props?.placeholder ? props?.placeholder : ct("rta-trmc.dashboard.searchInput.searchHere")}</InputLabel>
        <FilledInput
            id="filled-search"
            onChange={handleChange}
            value={props.pageSearch}
            endAdornment={<InputAdornment position="end">
                {
                    props.pageSearch ? <i className="fa fa-times fa-2x pointer"
                        onClick={handleClear}
                    ></i> : <i className="fa fa-search fa-2x"></i>
                }
            </InputAdornment>}
            aria-describedby="filled-search"
            inputProps={{
                'aria-label': ct("rta-trmc.dashboard.searchInput.searchHere"),
            }}

            sx={{
                width: width
            }}
        />
    </FormControl>)
}


export default SearchInput;